import React from "react";
import { resource } from "@planzone/dto";

import { Filter } from "@common/filter";
import { useToggle } from "@common/treeToggle";
import { Context } from "../../context";
import { Calendar } from "../calendar";
import { Props } from "./types";
import styles from "./styles.scss";

function Group({ group, filter, dates }: Props) {
  const { cell } = React.useContext(Context);
  const { isOpen } = useToggle(group.uuid, 0, true);

  return (
    <div className={styles.group}>
      <div className={styles.resource} style={{ height: cell.height }} />
      {isOpen && (
        <Filter
          filter={filter}
          data={group.workloads}
          extractCriteria={(workLoad) => ({
            resource: {
              ...resource,
              uuid: workLoad.uuid,
              name: workLoad.resourceName,
              profession: workLoad.resourceTitle || "",
              tags: workLoad.resourceTags.map((name) => ({ name })),
            },
          })}
        >
          {(workLoads) => (
            <Calendar dates={dates} workLoads={workLoads} isGroupCalendar />
          )}
        </Filter>
      )}
    </div>
  );
}

export { Group };
